var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRinuFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1819.777,
    height: 370.732,
    viewBox: "0 0 1819.777 370.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1819.777,
    height: 370.732,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(-787 -32.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(787 32.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M499.859.008V282.924L266.57.008H205.548V364.191h51.759l0-293.846L500.246,364.191H552.4V.008Z",
    transform: "translate(670.302 0.026)",
    fill: "#21333b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M0,.03,215.95,0c55.585,2.7,109.645,32.039,118.41,92.013,7.44,50.834-15.928,94.352-63.23,113.161-10.371,4.129-19.886,5.68-30.5,8.215-.9.247-1.4-.571-1.146,1.163l112,149.656H284.663l-107-145.348h-95l19.8-47.566,115.764-.111c87.33-5.706,83.661-117.2,1.577-123.494l-166.479.03V364.208H0Z",
    transform: "translate(0 0)",
    fill: "#21333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M399.2.007l-.051,216.9c3.375,143.273,240.5,140.461,241.866-2.356L640.973.007h53.314l.026,224.732c-4.444,95.4-74.628,142.2-163.372,145.749-96.1,3.809-180.852-41.008-185.816-146.567V.007Z",
    transform: "translate(1125.468 0.022)",
    fill: "#21333b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 53.31,
    height: 364.179,
    transform: "translate(567.695 0.026)",
    fill: "#21333b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRinuFooter);
export default __webpack_public_path__ + "static/media/RinuFooter.da11e22890292fc9630cbc24e8d0d007.svg";
export { ForwardRef as ReactComponent };